export default {
    title: "致谢",
    message: "<p>勾选此框，即表示我确认自己是 O-I 的员工，并同意 O-I 及其合作伙伴 DXC 和关联公司存储和处理我在本网站提交的个人信息，以便向我提供所需内容。DXC 及其关联公司需要我提供的联系信息，以便就我的订单与我联系。第三方供应商也将收到我的信息，以便向我发货。</p><p>有关隐私保护措施以及我们对保护和尊重我的隐私的承诺的更多信息，请查看<a href='{privacyPolicyUrl}' target='_blank' rel='noopener'>隐私政策</a></p>",
    tip: "点击复选框继续",
    submit: "提交",
}